<div class="top">
    <div class="heading">
        <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;">{{this.dialogData?.displayName || 'SUPER AGENT'}}</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
        close
    </i>
</div>


<div class="form-wrapper">
    <div class="details" style="border-bottom: 1px solid #e0e0e0; padding-bottom: 20px;">
        <div class="d-flex gap-3 flex-wrap justify-content-between">
            <div class="left d-flex flex-column gap-2">
                <div><strong class="fw-bold">ASIN: </strong> {{ this.details?.asin }}</div>
                <div><strong class="fw-bold">Phone: </strong> {{ this.details?.phoneNumber  }}</div>
                <div><strong class="fw-bold">Email: </strong> {{ this.details?.email }}</div>
                <div><strong class="fw-bold">Address: </strong> {{ this.details?.address }}</div>
                <div><strong class="fw-bold">LGA: </strong> {{ this.details?.lgaName | titlecase }}</div>
                <div><strong class="fw-bold">Zone: </strong> {{ this.details?.zoneName | titlecase }}</div>
            </div>

            <div class="d-flex flex-column gap-2 align-items-start align-items-sm-end ">
                <div class="d-flex align-items-center gap-1">
                    <span class="font-size-small">Agent Type:</span>
                    <span
                        style="background-color: #F2EACF; color: #686988; padding: 3px 15px; border-radius: 999px; font-size: 13px;">{{this.details?.roleName | removeUnderscore }}</span>
                </div>
                <div class="d-flex flex-column gap-1 align-items-start align-items-sm-end">
                    <p style="font-size: 13px; color: #6B6C7E;">Date of Registration:</p> <small class="fw-bold"
                        style="font-size: 13px;">{{ this.details?.createdAt | date }}</small>
                </div>
            </div>
        </div>
    </div>

    <form [formGroup]="form" class="mt-4">
        <div class="row g-2">
            <div class="col-md-6 field">
                <label for="name" class="required">PHONE NUMBER</label>

                <input type="text" formControlName="phoneNumber" class="form-control" placeholder="eg. 09087763552"  />


                <app-error-message [form]="form" controlName="phoneNumber" label="Phone Number"
                    [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>


            <div class="col-md-6 field">
                <label for="name" class="required">Address</label>

                <input type="text" formControlName="address" class="form-control" placeholder="Enter Address" />


                <app-error-message [form]="form" controlName="address" label="Address"
                    [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>

            

        </div>
    </form>



    <div class="modal-actions-wrapper mt-3">
        @if(isInEditingMode){
        <button type="submit" class="custom-btn-primary w-100" (click)="openConfirmModal()"
            [disabled]="form?.pristine || isSubmitting || form?.invalid">
            <ng-container *ngIf="!isSubmitting; else loadingTemplate">
                <span>Update Super Agent</span>
            </ng-container>
            <ng-template #loadingTemplate>
                <span>Saving...</span>
            </ng-template>
        </button>
        }
        @else {
        <a role="button" class="ms-auto d-flex align-items-center" style="text-decoration: none; gap: 2px; cursor: pointer; :hover {
                color: blue; 
            }" (click)="allowEditing()"><small class="material-icons" style="font-size: 18px;">edit</small> Edit</a>
        }


    </div>

</div>